<button matButton="filled" (click)="addProduct($event)">
    <div class="btn-content">
        <i class="fa-regular fa-cart-plus"></i>
    </div>
</button>
